import { InventoryActions, InventoryActionTypes } from '../../actions/account/actions-inventory';
import { InventoryState } from '../../models/account/inventory.state';

export const inventoryInitState: InventoryState = {
  isLoading: true,
  inventoryItems: []
};

/* eslint-disable */
export function reducersInventory(state = inventoryInitState, action: InventoryActions): InventoryState {
  switch (action.type) {
    case InventoryActionTypes.GetInventory:
      return { ...state, isLoading: true };

    case InventoryActionTypes.GetInventorySuccess:
      return { ...state, inventoryItems: action.payload, isLoading: false };

    default:
      return state;
  }
}
